export function logoRotation (logo, container, center) {
	// Mouse
	const mouse = {
		_x: 0,
		_y: 0,
		x: 0,
		y: 0,
		updatePosition: function (event) {
			var e = event || window.event;
			this.x = e.clientX - this._x;
			this.y = (e.clientY - this._y) * -1;
		},
		setOrigin: function (e) {
			this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
			this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
		},
		show: function () {
			return '(' + this.x + ', ' + this.y + ')';
		}
	};

	let counter = 0;
	const refreshRate = 10;
	const isTimeToUpdate = function () {
		return counter++ % refreshRate === 0;
	};

	const onMouseEnterHandler = function (event) {
		update(event);
	};
	const onMouseLeaveHandler = function () {
		$(logo).css({});
	};
	const onMouseMoveHandler = function (event) {
		if (!$(logo).hasClass('scrolled') && isTimeToUpdate()) {
			update(event);
		}
	};

	const update = function (event) {
		mouse.updatePosition(event);
		updateTransformStyle(((getCoords(center).left - mouse.x) / window.innerWidth * 5).toFixed(2));
	};

	function getCoords (elem) {
		const box = elem.getBoundingClientRect();

		const body = document.body;
		const docEl = document.documentElement;

		let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
		let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

		let clientTop = docEl.clientTop || body.clientTop || 0;
		let clientLeft = docEl.clientLeft || body.clientLeft || 0;

		let top = box.top + scrollTop - clientTop;
		let left = box.left + scrollLeft - clientLeft;

		return {
			top: top,
			left: left
		};
	}

	const updateTransformStyle = function (x) {
		let style = 'rotate(' + x + 'deg)';
		logo.style.transform = style;
		logo.style.webkitTransform = style;
		logo.style.mozTranform = style;
		logo.style.msTransform = style;
		logo.style.oTransform = style;
	};

	container.onmouseenter = onMouseEnterHandler;
	container.onmouseleave = onMouseLeaveHandler;
	container.onmousemove = onMouseMoveHandler;
}
